import React from 'react';
import  './styles/totalBar.scss';

const Label = (props) => {
    const {children} = props
    return (
        <div className="label">
            {children}
        </div>
    );
};

export {Label};